<template>
  <v-container fill-height class="text-center">
    <v-layout v-if="plans.length" align-center justify-center>
      <v-flex v-for="plan in plans" :key="plan.id" xs12 md4 class="mx-3">
        <v-card v-if="plan.interval === 'month' || (plan.interval == 'year' && currentCompany.id != 137)" class="subscriptionBox" light align-center justify-center width="100%"> <!-- Added class="text-center" here -->
          <v-card-title class="justify-center pb-0">
            <h2 class="greyDarken3--text">{{plan.metadata.plan_name}}</h2>
          </v-card-title>
          <v-card-title class="justify-center pt-0">
              <h1><span class="pr-1">{{getCurrencySymbol(plan.currency)}}</span>{{transformFromSubUnit(plan.amount)}}</h1>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="py-0">
            <v-list class="mx-2">
                <v-list-tile
                  v-for="(feature, i) in DEFINES.PRICING_PLANS[plan.interval].features"
                  :key="i"
                  avatar
                >
                  <v-list-tile-action>
                    <v-icon color="success">check</v-icon>
                  </v-list-tile-action> 
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle v-text="feature"></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-tile>
              </v-list>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions v-if="!isConsumerSubscribed" class="justify-center py-3">
            <v-btn large color="primary" @click="initSubscriptionCheckout(plan)" dark slot="activator">{{ $t('company.pricing.plan.subscribe') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <SubscriptionCheckoutDialog 
      :btnText="$t('company.pricing.plan.subscribe')" 
      :plan.sync="selectedPlan" 
      :dialog.sync="dialog"
      @reset="resetCheckout"
      @close="closeCheckout"
      />
    </v-layout>
    <v-layout v-else align-center justify-center column>
      <v-icon color="grey" size="80">mdi-package-variant-closed</v-icon>
      <h1 class="mt-4 text-h4 font-weight-bold">{{ $t('subscription.no_plans.headline') }}</h1>
      <p class="grey--text title mt-2">{{ $t('subscription.no_plans.desc') }}</p>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { currencySymbol } from "@/mixins/currencySymbol";
import SubscriptionCheckoutDialog from '@/components/subscription/SubscriptionCheckoutDialog.vue';

export default {
  name: "Plans",
  data() {
    return {
      plans: [],
      dialog:false,
      selectedPlan:null
    }
  },
  components: {
    SubscriptionCheckoutDialog
  },
  computed: {
    ...mapState({
      companies: state => state.company.list,
      currentCompany: state => state.company.company,
    }),
    ...mapGetters("consumer", {
      isConsumerSubscribed: "isSubscribed"
    })
  },
  mixins: [currencySymbol],
  mounted() {
    this.getPricingPlans();
  },

  methods: {
    async getPricingPlans() {
      await this.$store.dispatch('plan/getPlans')
      .then((response) => {
        this.plans =  response.plans
      })
    },

    transformFromSubUnit(amount){
      return (amount / 100).toFixed(2);
    },
    initSubscriptionCheckout(plan){
      this.setSelectedPlan(plan);
      this.dialog = true;
    },
    setSelectedPlan(plan){
      this.selectedPlan = plan;
      this.selectedPlan.price = this.transformFromSubUnit(plan.amount);
      this.selectedPlan.type = this.DEFINES.MONETIZATION.PRICING_TYPE.SUBSCRIPTION;
      this.selectedPlan.name = plan.metadata.plan_name;
    },
    /* 
      Will be used when consumer doesn't want to proceed.
    */
    resetCheckout(){
      this.selectedPlan = null;
      this.closeCheckout();
    },
    /* 
      Will be used when enrollment popup is shown & checkout is hidden. 
      So a plan must be kept as selected 
    */
    closeCheckout(){
      this.dialog = false;
    }
  }
};
</script>
<style>
  .subscriptionBox {
    border-radius: 10px;
  }
</style>
